import Axios from "axios";
import {
  antdAsyncMessageError,
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
} from "../../helpers/AsyncMessage";
import { errorHandler } from "../../helpers/Utils";

export const getSetting = async (log_item) => {
  try {
    const { data } = await Axios.get(`/api/v1/settings?log_item=${log_item}`);
    console.log({ data });
    if (!data.success) throw new Error("ERR");

    return { success: true, data: data.data };
  } catch (err) {
    errorHandler(err);
    return { success: false };
  }
};

export const updateSettings = async (log_item, body = "") => {
  const key = "updateSettings";
  console.log({ key });
  try {
    antdAsyncMessageLoading({ key });
    const { data } = await Axios.post("/api/v1/settings", {
      log_item,
      body,
    });
    console.log({ data });
    if (!data.success) throw new Error("ERR");
    antdAsyncMessageSuccess({ key });

    return { success: true, data: data.data };
  } catch (err) {
    errorHandler(err);
    antdAsyncMessageError({ key });
    return { success: false };
  }
};
